const translation = {
  toVerifiedTip: {
    front: 'Vous êtes maintenant éligible pour le statut Vérifié en Éducation. Veuillez entrer vos informations éducatives ci-dessous pour compléter le processus et recevoir un',
    coupon: 'coupon exclusif 100%',
    end: 'pour le Plan Professionnel Dify.',
  },
  form: {
    schoolName: {
      placeholder: 'Entrez le nom officiel et complet de votre école',
      title: 'Le nom de votre école',
    },
    schoolRole: {
      option: {
        administrator: 'Administrateur scolaire',
        student: 'Étudiant',
        teacher: 'Professeur',
      },
      title: 'Votre rôle à l\'école',
    },
    terms: {
      desc: {
        and: 'et',
        privacyPolicy: 'Politique de confidentialité',
        termsOfService: 'Conditions d\'utilisation',
        end: '. En soumettant :',
        front: 'Vos informations et votre utilisation du statut Éducation Vérifiée sont soumises à notre',
      },
      option: {
        age: 'Je confirme que j\'ai au moins 18 ans.',
        inSchool: 'Je confirme que je suis inscrit ou employé dans l\'institution indiquée. Dify peut demander une preuve d\'inscription/employé. Si je falsifie mon éligibilité, j\'accepte de payer tous les frais initialement annulés en fonction de mon statut éducatif.',
      },
      title: 'Conditions et accords',
    },
  },
  emailLabel: 'Votre email actuel',
  learn: 'Apprenez comment faire vérifier votre éducation',
  currentSigned: 'ACTUELLEMENT CONNECTÉ EN TANT QUE',
  successTitle: 'Vous avez obtenu une éducation Dify vérifiée.',
  successContent: 'Nous avons émis un coupon de réduction de 100 % pour le plan Dify Professionnel sur votre compte. Le coupon est valable pendant un an, veuillez l\'utiliser dans la période de validité.',
  rejectTitle: 'Votre vérification éducative Dify a été rejetée.',
  submit: 'Soumettre',
  submitError: 'L\'envoi du formulaire a échoué. Veuillez réessayer plus tard.',
  toVerified: 'Faire vérifier l\'éducation',
  rejectContent: 'Malheureusement, vous n\'êtes pas éligible au statut Éducation Vérifié et ne pouvez donc pas recevoir le coupon exclusif de 100 % pour le Plan Professionnel Dify si vous utilisez cette adresse e-mail.',
}

export default translation
